import React from 'react'
import PropTypes from 'prop-types'

import { Image, Text } from 'Components/UI'

import find from 'lodash/find'
import isFunction from 'lodash/isFunction'

import { TECHNOLOGIES } from 'Constants/Projects/technologies'

import { Container, ImageHolder } from './styles'

function Plate({ technologyName, invert, ...rest }) {
  const technology = find(TECHNOLOGIES, { name: technologyName })
  const { logo } = technology

  return (
    <Container {...rest}>
      <ImageHolder mr={['8px', 16]}>
        {isFunction(logo) ? (
          logo({ width: 32 })
        ) : (
          /* decorative (the name renders beside it); 32px display slot */
          <Image alt="" image={logo} layout="intrinsic" lazy sizes="32px" />
        )}
      </ImageHolder>
      <Text as="h3" medium white={!invert}>
        {technology.name}
      </Text>
    </Container>
  )
}

Plate.defaultProps = {
  invert: 0,
  technologyName: '',
}

Plate.propTypes = {
  invert: PropTypes.number,
  technologyName: PropTypes.string,
}

export default Plate
